import { orderBy as lodashSort } from 'lodash'

import {
  COACHING_INBOX,
  COMPLIANCE_INBOX,
  PROMPT_ENGINEER_INBOX,
  QA_INBOX,
} from '@/reducers/tasks/tasks.constants'
import { getStringValueFromBoolean } from '@/utils/helpers'

export const TODO = 'todo'
export const ARCHIVE = 'archive'
export const MANUAL_COMPLIANCE_TYPE = 'Manual'

// Prompt feedback groups by prompt rather than by agent, so it has no agent to filter on
export const AGENT_FILTER_INBOXES = [COACHING_INBOX, COMPLIANCE_INBOX, QA_INBOX]

export const taskTypeOptions = [
  { label: 'Dismissed', value: 'ignored' },
  { label: 'Reviewed', value: 'completed' },
]
export const qaTypeOptions = [
  { value: 'qa_dispute', label: 'Agent Disputes' },
  { value: 'qa_manual_score', label: 'Manual Scores' },
]

export const taskAgentReviewedOptions = [
  { label: 'Acknowledged', value: 'true' },
  { label: 'Not Acknowledged', value: 'false' },
]

export const getSortByOptions = (inboxType) => {
  const sortByOptions = [
    { label: 'Recently Updated', value: 'updated_at' },
    { label: 'Creation Date', value: 'created_at' },
  ]

  if (inboxType === PROMPT_ENGINEER_INBOX) {
    sortByOptions.push({
      label: 'Number of Reports',
      value: 'feedback_count',
    })
  } else if (inboxType !== QA_INBOX) {
    sortByOptions.push({
      label: 'Number of Related Calls',
      value: 'evidence_count',
    })
  }

  return sortByOptions
}

export const DEFAULT_SORT_CONFIG = { sortBy: 'updated_at', orderBy: 'desc' }

export const inboxSort = (items = [], sortConfig = DEFAULT_SORT_CONFIG) => {
  return lodashSort(items, sortConfig.sortBy, sortConfig.orderBy)
}

export const getVisibleTasks = ({
  isArchive,
  allTodoTasks,
  allArchivedTasks,
  taskType,
  taskStatus,
  taskAgentReviewed,
  taskCreatedBy,
  complianceType,
  sortConfig,
  currentUserId,
  inboxType,
}) => {
  const currentTasks = isArchive ? allArchivedTasks : allTodoTasks
  const sortedTasks = inboxSort(currentTasks, sortConfig)

  const filteredTasks = sortedTasks
    .filter((task) => {
      if (inboxType === QA_INBOX) {
        return true
      }
      if (taskCreatedBy === 'my') {
        return task.created_by === currentUserId
      }
      return true
    })
    // Task Type: Only applied to QA Inbox right now, the rest only have one type
    .filter((task) => {
      if (!taskType) {
        return true
      }
      return task.type === taskType
    })
    .filter((task) => {
      if (complianceType && inboxType === COMPLIANCE_INBOX) {
        if (complianceType === MANUAL_COMPLIANCE_TYPE) {
          return !task.ai_generated
        }
        return task.name === complianceType
      }

      return true
    })
    // Status: IGNORED, EXPIRED, COMPLETED - only for archived tasks
    .filter((task) => {
      if (!isArchive) {
        return true
      }
      if (taskStatus) {
        return task.status === taskStatus
      }

      return true
    })
    // Agent Reviewed: true, false - only for archived tasks
    .filter((task) => {
      if (!isArchive) {
        return true
      }

      if (taskAgentReviewed) {
        return getStringValueFromBoolean(task.agent_reviewed) === taskAgentReviewed
      }

      return true
    })

  return filteredTasks
}

export const getTestIdForTask = (task) => {
  let generatedBy

  if (task.scorecard_criteria_scid) {
    generatedBy = 'scorecard'
  } else if (task.prompt_id) {
    generatedBy = 'button'
  } else if (!task.ai_generated) {
    generatedBy = 'manual'
  } else {
    generatedBy = ''
  }

  return `${task.type}-${generatedBy}`
}

export const parseComplianceTypeFilter = (complianceType) => {
  if (!complianceType) {
    return { aiGenerated: null, taskName: null }
  }
  if (complianceType === MANUAL_COMPLIANCE_TYPE) {
    return { aiGenerated: false, taskName: null }
  }
  return { aiGenerated: true, taskName: complianceType }
}
